/* Due Lune — visualizzatore immagini PDP con zoom gestibile.
   Sostituisce il lightbox di Dawn (che su mobile apre l'immagine a 1100px fissi):
   - apre la foto intera, adattata allo schermo
   - pinch a due dita, doppio tap, pulsanti −/+, rotellina, tastiera
   - trascinamento quando zoomata, swipe tra le foto, swipe in basso per chiudere
   Dati immagini: <script type="application/json" id="DlZoomData-..."> in main-product. */
(() => {
  if (window.__dlZoomInit) return;
  window.__dlZoomInit = true;

  const DOUBLE_TAP_MS = 300;
  const DOUBLE_TAP_PX = 30;
  const SWIPE_PX = 50;
  const CLOSE_PX = 110;
  const TAP_ZOOM = 2.5;
  const INSET_TOP = 56;
  const INSET_BOTTOM = 76;

  let data = null;
  let maxScale = 4;
  let root, stage, img, counter, pct, btnIn, btnOut, btnPrev, btnNext, hint;
  let idx = 0;
  let s = 1, tx = 0, ty = 0;
  let base = { x: 0, y: 0, w: 0, h: 0 };
  let sw = { x: 0, y: 0 };
  let gesture = null;
  let lastTap = { t: 0, x: 0, y: 0 };
  let lastFocus = null;
  const pointers = new Map();

  const readData = () => {
    const el = document.querySelector('[id^="DlZoomData-"]');
    if (!el) return null;
    try {
      const arr = JSON.parse(el.textContent);
      maxScale = parseFloat(el.dataset.max) || 4;
      return arr.length ? arr : null;
    } catch (e) {
      return null;
    }
  };

  const svgClose =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path stroke-linecap="round" d="M5 5l14 14M19 5L5 19"/></svg>';

  const build = () => {
    root = document.createElement('div');
    root.className = 'dl-zoom';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Visualizzatore immagini');
    root.innerHTML = `
      <div class="dl-zoom__stage"><img class="dl-zoom__img" alt="" draggable="false"></div>
      <div class="dl-zoom__top">
        <span class="dl-zoom__counter" aria-live="polite"></span>
        <button type="button" class="dl-zoom__close" aria-label="Chiudi">${svgClose}</button>
      </div>
      <button type="button" class="dl-zoom__nav dl-zoom__nav--prev" aria-label="Foto precedente">&#8249;</button>
      <button type="button" class="dl-zoom__nav dl-zoom__nav--next" aria-label="Foto successiva">&#8250;</button>
      <div class="dl-zoom__bar">
        <button type="button" class="dl-zoom__btn" data-z="out" aria-label="Riduci zoom">&minus;</button>
        <span class="dl-zoom__pct">100%</span>
        <button type="button" class="dl-zoom__btn" data-z="in" aria-label="Aumenta zoom">+</button>
      </div>
      <div class="dl-zoom__hint" aria-hidden="true">Pizzica o tocca due volte per ingrandire</div>`;
    document.body.appendChild(root);

    stage = root.querySelector('.dl-zoom__stage');
    img = root.querySelector('.dl-zoom__img');
    counter = root.querySelector('.dl-zoom__counter');
    pct = root.querySelector('.dl-zoom__pct');
    btnIn = root.querySelector('[data-z="in"]');
    btnOut = root.querySelector('[data-z="out"]');
    btnPrev = root.querySelector('.dl-zoom__nav--prev');
    btnNext = root.querySelector('.dl-zoom__nav--next');
    hint = root.querySelector('.dl-zoom__hint');

    root.querySelector('.dl-zoom__close').addEventListener('click', close);
    btnIn.addEventListener('click', () => zoomAtCenter(s * 1.5));
    btnOut.addEventListener('click', () => zoomAtCenter(s / 1.5));
    btnPrev.addEventListener('click', () => go(-1));
    btnNext.addEventListener('click', () => go(1));
    img.addEventListener('dragstart', (e) => e.preventDefault());

    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', () => root.classList.contains('is-open') && fit());
    root.addEventListener('keydown', onKey);
  };

  /* ---------- geometria ---------- */
  const fit = () => {
    const m = data[idx];
    const W = stage.clientWidth;
    const H = stage.clientHeight;
    const availH = Math.max(H - INSET_TOP - INSET_BOTTOM, 100);
    const r = Math.min(W / m.w, availH / m.h);
    base.w = m.w * r;
    base.h = m.h * r;
    base.x = (W - base.w) / 2;
    base.y = INSET_TOP + (availH - base.h) / 2;
    img.style.width = base.w + 'px';
    img.style.height = base.h + 'px';
    s = 1;
    tx = 0;
    ty = 0;
    render();
  };

  const clamp = () => {
    const W = stage.clientWidth;
    const H = stage.clientHeight;
    const availH = H - INSET_TOP - INSET_BOTTOM;
    const w = base.w * s;
    const h = base.h * s;
    if (w <= W) tx = (W - w) / 2 - base.x;
    else tx = Math.min(-base.x, Math.max(W - w - base.x, tx));
    if (h <= availH) ty = INSET_TOP + (availH - h) / 2 - base.y;
    else if (h <= H) ty = (H - h) / 2 - base.y;
    else ty = Math.min(-base.y, Math.max(H - h - base.y, ty));
  };

  const render = () => {
    img.style.transform = `translate3d(${base.x + tx + sw.x}px, ${base.y + ty + sw.y}px, 0) scale(${s})`;
    img.style.opacity = sw.y > 0 ? Math.max(0.4, 1 - sw.y / 400) : '';
    pct.textContent = Math.round(s * 100) + '%';
    btnIn.disabled = s >= maxScale - 0.01;
    btnOut.disabled = s <= 1.01;
    root.classList.toggle('is-zoomed', s > 1.01);
  };

  const animate = (on) => img.classList.toggle('is-anim', on);

  const zoomAt = (ns, cx, cy) => {
    ns = Math.min(maxScale, Math.max(1, ns));
    const px = (cx - base.x - tx) / s;
    const py = (cy - base.y - ty) / s;
    s = ns;
    tx = cx - base.x - s * px;
    ty = cy - base.y - s * py;
    clamp();
    render();
  };

  const zoomAtCenter = (ns) => {
    animate(true);
    zoomAt(ns, stage.clientWidth / 2, stage.clientHeight / 2);
  };

  const local = (e) => {
    const r = stage.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

  /* ---------- gesture ---------- */
  const startSingle = (p) => {
    gesture = {
      type: s > 1.01 ? 'pan' : 'swipe',
      x0: p.x,
      y0: p.y,
      tx0: tx,
      ty0: ty,
      moved: false,
    };
  };

  function onDown(e) {
    try {
      stage.setPointerCapture(e.pointerId);
    } catch (err) {}
    pointers.set(e.pointerId, local(e));
    animate(false);
    hideHint();
    if (pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      const m0 = mid(a, b);
      gesture = {
        type: 'pinch',
        d0: dist(a, b) || 1,
        s0: s,
        px: (m0.x - base.x - tx) / s,
        py: (m0.y - base.y - ty) / s,
      };
      sw = { x: 0, y: 0 };
    } else if (pointers.size === 1) {
      startSingle(local(e));
    }
  }

  function onMove(e) {
    if (!pointers.has(e.pointerId) || !gesture) return;
    const p = local(e);
    pointers.set(e.pointerId, p);

    if (gesture.type === 'pinch' && pointers.size >= 2) {
      const [a, b] = [...pointers.values()];
      const m = mid(a, b);
      s = Math.min(maxScale, Math.max(1, (gesture.s0 * dist(a, b)) / gesture.d0));
      tx = m.x - base.x - s * gesture.px;
      ty = m.y - base.y - s * gesture.py;
      clamp();
      render();
      return;
    }

    const dx = p.x - gesture.x0;
    const dy = p.y - gesture.y0;
    if (Math.hypot(dx, dy) > 6) gesture.moved = true;

    if (gesture.type === 'pan') {
      tx = gesture.tx0 + dx;
      ty = gesture.ty0 + dy;
      clamp();
      render();
    } else if (gesture.type === 'swipe' && gesture.moved) {
      if (Math.abs(dx) >= Math.abs(dy)) sw = { x: dx, y: 0 };
      else sw = { x: 0, y: Math.max(0, dy) };
      render();
    }
  }

  function onUp(e) {
    if (!pointers.has(e.pointerId)) return;
    const p = local(e);
    pointers.delete(e.pointerId);
    if (!gesture) return;

    if (gesture.type === 'pinch') {
      if (pointers.size === 1) {
        startSingle([...pointers.values()][0]);
        gesture.moved = true;
      } else {
        gesture = null;
      }
      if (s < 1.02) {
        animate(true);
        s = 1;
        clamp();
        render();
      }
      return;
    }

    const g = gesture;
    gesture = null;

    if (g.type === 'swipe' && g.moved) {
      const dx = sw.x;
      const dy = sw.y;
      sw = { x: 0, y: 0 };
      animate(true);
      if (Math.abs(dx) > SWIPE_PX && data.length > 1) {
        go(dx < 0 ? 1 : -1);
      } else if (dy > CLOSE_PX) {
        close();
      } else {
        render();
      }
      return;
    }

    if (!g.moved) handleTap(p);
  }

  const handleTap = (p) => {
    const now = Date.now();
    if (now - lastTap.t < DOUBLE_TAP_MS && Math.hypot(p.x - lastTap.x, p.y - lastTap.y) < DOUBLE_TAP_PX) {
      lastTap.t = 0;
      animate(true);
      if (s > 1.01) {
        s = 1;
        clamp();
        render();
      } else {
        zoomAt(TAP_ZOOM, p.x, p.y);
      }
    } else {
      lastTap = { t: now, x: p.x, y: p.y };
    }
  };

  function onWheel(e) {
    e.preventDefault();
    animate(false);
    const p = local(e);
    zoomAt(s * Math.exp(-e.deltaY * 0.0015), p.x, p.y);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === '+' || e.key === '=') zoomAtCenter(s * 1.5);
    else if (e.key === '-') zoomAtCenter(s / 1.5);
    else return;
    e.preventDefault();
  }

  /* ---------- navigazione ---------- */
  const load = (i) => {
    idx = (i + data.length) % data.length;
    const m = data[idx];
    img.src = m.src;
    img.alt = m.alt || '';
    counter.textContent = data.length > 1 ? `${idx + 1} / ${data.length}` : '';
    fit();
    [idx + 1, idx - 1].forEach((n) => {
      const pre = data[(n + data.length) % data.length];
      if (pre) new Image().src = pre.src;
    });
  };

  const go = (n) => {
    animate(false);
    sw = { x: 0, y: 0 };
    load(idx + n);
  };

  let hintTimer = null;
  const hideHint = () => {
    if (hint) hint.classList.remove('is-visible');
    clearTimeout(hintTimer);
  };

  const open = (i) => {
    if (!root) build();
    lastFocus = document.activeElement;
    const multi = data.length > 1;
    btnPrev.hidden = !multi;
    btnNext.hidden = !multi;
    root.classList.add('is-open');
    document.documentElement.classList.add('dl-zoom-lock');
    load(i);
    root.querySelector('.dl-zoom__close').focus({ preventScroll: true });

    let seen = false;
    try {
      seen = sessionStorage.getItem('dlZoomHint') === '1';
      sessionStorage.setItem('dlZoomHint', '1');
    } catch (err) {}
    if (!seen && window.matchMedia('(pointer: coarse)').matches) {
      hint.classList.add('is-visible');
      hintTimer = setTimeout(hideHint, 2600);
    }
  };

  function close() {
    if (!root) return;
    hideHint();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('dl-zoom-lock');
    pointers.clear();
    gesture = null;
    sw = { x: 0, y: 0 };
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- aggancio: intercetta il click prima del lightbox di Dawn ---------- */
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.product__media-toggle');
      if (!btn || !btn.closest('[id^="MainProduct-"]')) return;
      data = data || readData();
      if (!data) return;
      const i = data.findIndex((m) => String(m.id) === String(btn.dataset.mediaId));
      if (i < 0) return; // video o modello 3D: resta il comportamento di Dawn
      e.preventDefault();
      e.stopImmediatePropagation();
      open(i);
    },
    true
  );
})();
